export default "/images/minplan-icon.svg?8275bfaab01cfd98000da45e231da21a";